export function extractOrgFromHost(hostname: string): string | undefined {
  const parts = hostname.split('.');
  const i = parts.indexOf('clients');
  return i > 0 ? parts[i - 1] : undefined;
}
